import React, { createContext, useContext, useState, useEffect } from "react";
import { doc, setDoc } from "firebase/firestore"; 
import { db } from "../firebase";
import { auth } from "../firebase";
import { 
  createUserWithEmailAndPassword, 
  signInWithEmailAndPassword, 
  signOut, 
  onAuthStateChanged 
} from "firebase/auth";

// ✅ Create context
const AuthContext = createContext();

// ✅ Custom hook
function useAuth() {
  return useContext(AuthContext);
}

// ✅ AuthProvider component
function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);

  async function signup(email, password, username, state) {
    const userCredential = await createUserWithEmailAndPassword(auth, email, password);
    const user = userCredential.user;

    await setDoc(doc(db, "users", user.uid), {
      username,
      state,
      company: "",
      department: "",
      position: "",
      city: "",
      workLocation: "",
      yearsOnJob: "",
      employmentStatus: "",
    });

    return userCredential;
  }

  function login(email, password) {
    return signInWithEmailAndPassword(auth, email, password);
  }

  function logout() {
    return signOut(auth);
  }

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setCurrentUser(user);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  return (
    <AuthContext.Provider value={{ currentUser, signup, login, logout }}>
      {!loading && children}
    </AuthContext.Provider>
  );
}

// ✅ Final export — no duplicates
export { AuthContext, AuthProvider, useAuth };
